import {createBrowserHistory} from 'history';

export const history = createBrowserHistory({
  basename: /^\/invitation-maker/.test(window.location.pathname)
    ? '/invitation-maker'
    : '/invitation/',
});
